import { IClientKnowledgeState } from './state';

export const clientKnowledgeInitialState: IClientKnowledgeState = {
  isFetching: false,
  error: ''
};
